<template>
  <b-overlay
    :show="loading"
    rounded="sm"
  >
    <b-row>
      <b-col>
        <b-card
          title="جزئیات غذا پیشنهادی"
        >
          <b-form
            ref="foodsuggestionform"
            @submit.prevent
          >
            <b-row>

              <b-col
                class="mt-2"
                md="6"
                offset-md="3"
              >
                <b-row>

                  <b-col
                    class="image"
                    cols="12"
                  >
                    <b-media class="mb-2">
                      <template #aside>
                        <b-avatar
                          ref="previewEl"
                          :src="Form.Image"
                          size="90px"
                          rounded
                        />
                      </template>
                      <div class="d-flex flex-wrap align-self-end">
                        <b-button
                          variant="outline-info"
                          @click="$refs.refInputEl.click()"
                        >
                          <input
                            ref="refInputEl"
                            type="file"
                            class="d-none"
                            name="Image"
                            @input="imageRenderer"
                          >
                          <span class="d-none d-sm-inline">انتخاب عکس</span>
                          <feather-icon
                            icon="EditIcon"
                            class="d-inline d-sm-none"
                          />
                        </b-button>
                      </div>
                    </b-media>
                  </b-col>

                  <b-col md="6">
                    <b-form-group
                      label="عنوان"
                      label-for="Title"
                    >
                      <b-form-input
                        id="Title"
                        v-model="Form.Title"
                        name="Title"
                        autocomplete="off"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group
                        label="معادل فارسی"
                        label-for="PersianEquivalent"
                    >
                      <b-form-input
                          id="PersianEquivalent"
                          v-model="Form.PersianEquivalent"
                          name="PersianEquivalent"
                          autocomplete="off"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group
                        label="وضعیت"
                        label-for="Status"
                    >
                      <v-select
                          v-model="Form.Status"
                          name="Status"
                          dir="rtl"
                          :reduce="x => x.value"
                          label="text"
                          input-id="Status"
                          :clearable="false"
                          :options="Status"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                        label="دسته بندی"
                        label-for="FoodCategoryId"
                    >
                      <z-food-category
                          v-model="Form.FoodCategoryId"
                          :multiple="false"
                          :clearable="true"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                        label="وعده"
                        label-for="FoodMealId"
                    >
                      <z-food-meal
                          v-model="Form.FoodMealId"
                          :multiple="false"
                          :clearable="true"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                        label="استان"
                        label-for="StateId"
                    >
                      <z-state v-model="Form.StateId" />
                    </b-form-group>
                  </b-col>

                  <b-col cols="12">
                    <b-form-group
                      label="توضیحات یا دستور پخت"
                      label-for="Recipes"
                    >
                      <b-form-textarea
                        id="Description"
                        v-model="Form.Description"
                        name="Description"
                        rows="3"
                        no-resize
                      />
                    </b-form-group>
                  </b-col>

                  <b-col cols="12">
                    <hr>
                  </b-col>

                  <b-col class="mt-1 mb-2 text-center">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      type="submit"
                      variant="primary"
                      class="mr-1"
                      @click="save"
                    >
                      ذخیره
                    </b-button>
                    <b-button
                      v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                      variant="outline-secondary"
                      @click="back"
                    >
                      بازگشت
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>

import ZFoodCategory from "@/tools/foodcategory";
import ZFoodMeal from "@/tools/foodmeal";
import ZState from "@/tools/state";

export default {
  name: 'FoodSuggestionDetails',
  components: {
    ZFoodCategory,
    ZFoodMeal,
    ZState,
  },
  data() {
    return {
      Status: [],
      Form: {
        Id: null,
        Title: null,
        Image: null,
        Description: null,
        StateId: null,
        FoodCategoryId: null,
        FoodMealId: null,
        PersianEquivalent: null,
      },
      loading: false,
    }
  },
  created() {
    this.Status = this.enums('Status')
    this.Form.Id = this.$route.params.id
    this.get()
  },
  methods: {
    save() {
      const url = this.$api.foodsuggestion.update

      const formData = new FormData(this.$refs.foodsuggestionform)
      formData.append('Status', this.Form.Status)
      formData.append('Id', this.Form.Id)

      if (this.Form.FoodMealId){
        formData.append('FoodMealId', this.Form.FoodMealId)
      }

      if (this.Form.FoodCategoryId){
        formData.append('FoodCategoryId', this.Form.FoodCategoryId)
      }

      if (this.Form.StateId){
        formData.append('StateId', this.Form.StateId)
      }

      this.loading = true
      this.$http.post(
        url, formData,
      )
        .then(() => {
          this.back()
        })
        .finally(() => {
          this.loading = false
        })
    },
    imageRenderer(event) {
      const fileReader = new FileReader()
      fileReader.readAsDataURL(event.target.files[0])

      fileReader.onload = () => {
        this.Form.Image = fileReader.result
      }
    },
    get() {
      this.loading = true
      this.$http.post(
        this.$api.foodsuggestion.get, {
          Id: this.Form.Id,
        },
      )
        .then(res => {
          this.loading = false
          this.Form = res.data
        })
    },
  },
}
</script>

<style scoped>
.image .media-body {
  align-self: flex-end;
}
</style>
